import { Component, inject, Injector, runInInjectionContext } from '@angular/core';
import { retriveCurrentRouteData, SiaNewRouterService, SiaRouteData } from '@sia/shared';
import { Subscription } from 'rxjs';
import { SiaPdfViewerComponent } from '../../components/sia-pdf-viewer/sia-pdf-viewer.component';
import { PortalDocumentService } from '../../services/portal-document.service';

@Component({
  selector: 'sia-resources-document-viewer',
  templateUrl: './sia-resources-document-viewer.component.html',
  styleUrls: ['./sia-resources-document-viewer.component.css'],
  standalone: true,
  imports: [SiaPdfViewerComponent],
})
export class SiaResourceDocumentViewerComponent {
  private routerService = inject(SiaNewRouterService);
  private portalDocumentService = inject(PortalDocumentService);
  private injector: Injector = inject(Injector);

  private _subs: Subscription[] = [];
  pageData: SiaRouteData = {};
  file: any;

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  loadFile() {
    if (!this.pageData.componentId) {
      return;
    }
    let filePath = this.portalDocumentService.getResourcesUrl(this.pageData.componentId ?? '');
    let url: URL = new URL(filePath);
    this.file = url;
  }

  ngAfterViewInit() {
    let s0 = this.routerService.routeChanged$.subscribe(() => {
      var pageData: any = null;
      runInInjectionContext(this.injector, () => {
        pageData = retriveCurrentRouteData() ?? {};
      });
      if (!pageData?.guid || pageData?.guid == this.pageData?.guid) {
        return;
      }
      this.pageData = pageData!;
      this.loadFile();
    });
    this._subs.push(s0);
  }
}
